// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import bellRinging04Icon from "@/assets/icons/bell-ringing-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BellRinging04IconProps = Omit<IconProps, "name">;

export function BellRinging04Icon(props: BellRinging04IconProps): React.ReactNode {
  return <Icon name={bellRinging04Icon} {...props} />;
}
